import { on } from '@ember/modifier';

import { t } from 'ember-intl';
import onKey from 'ember-keyboard/modifiers/on-key';

import Button from 'umg-ember-backend/components/ui/button';
import recordHeadlineOrNew from 'umg-ember-backend/helpers/record-headline-or-new';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from '../styles.module.css';

const bem = getBem(styles);

<template>
  <div class={{(bem)}} ...attributes>
    <h2 class={{bem 'title'}}>
      {{t @confirm.title}}
    </h2>
    <div class={{bem 'message'}}>
      {{t
        @confirm.message
        title=(recordHeadlineOrNew @confirm.options.currentRoute.model)
        htmlSafe=true
      }}
    </div>

    <Button
      @icon='reset'
      @label={{t 'application.confirm.rollback.confirm'}}
      @style='primary'
      {{on 'click' @confirm.confirm}}
      {{onKey 'Enter' @confirm.confirm}}
    />

    <Button
      @icon='close'
      @label={{t 'application.confirm.rollback.cancel'}}
      @style='outline'
      {{on 'click' @confirm.cancel}}
      {{onKey 'Escape' @confirm.cancel}}
    />
  </div>
</template>
